import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import RenameModalContainer from '@/src/components/project/Common/Modals/RenameModal/RenameModalContainer';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { FileEntry } from '@/src/components/project/Inbox2/types';
import {
  setDocument,
  toggleRenameModal,
} from '@/src/reducers/project/renameModal/renameModal.actions';
import { RootState } from '@/src/reducers/types';

import { useFileEntryViewerSidebarActions } from '../../../../store/fileEntryViewer.sidebarActions.store';

type RenameFileProps = {
  fileEntry: FileEntry;
};

const RenameFile = ({ fileEntry }: RenameFileProps) => {
  const showRenameModal = useSelector((store: RootState) => store.renameModal.showModal);
  const dispatch = useDispatch();
  const { sidebarActions } = useFileEntryViewerSidebarActions();
  const { renameFileMutation } = sidebarActions;

  const document = {
    id: fileEntry.file.id,
    documentId: fileEntry.file.id,
    name: fileEntry.file.rawName,
    origin: fileEntry.file.name,
  };

  useEffect(() => {
    if (showRenameModal) {
      dispatch(setDocument(document));
    }
  }, [showRenameModal]);

  const handleClick = async () => {
    localStorage.setItem('page', 'Inbox');
    dispatch(toggleRenameModal(true));
  };

  const handleSave = async (newName) => {
    return renameFileMutation.mutateAsync({ newName });
  };

  return (
    <React.Fragment>
      <ActionButton
        id={'rename_document'}
        className={clsx('tw-w-full', 'tw-justify-between')}
        onClick={handleClick}
        label={'Rename'}
        icon={ICONS.edit}
      />

      {showRenameModal && (
        <ModalPortal>
          <RenameModalContainer customSave={handleSave} selected={document} />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};

export default RenameFile;
